import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const ResetPassword = withAsync({
	loader: lazyForPaint(() => import(/* webpackChunkName: "reset-password" */ './hocs')),
});
